// src/pages/CivilEngineering.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DepartmentHero,
  DepartmentAbout,
  DepartmentCTA,
  DepartmentServices,
} from '../components/departments';
import Counter from '../components/Counter';
import Testimonials from '../components/Testimonials';

// Icônes
import {
  faClipboard,
  faBuilding,
  faRoad,
  faPencilRuler,
  faMap,
  faUsers,
  faFileAlt,
  faFolder,
  faAward,
} from '@fortawesome/free-solid-svg-icons';

// Images
import chefImage from '../images/DGC_ATC_450X500.webp';
import logoCivil from '../images/logo ATC génie civil.webp';
import etudeTechImg from '../images/etude_technique_gc_458x500.webp';
import batimentImg from '../images/batiment_gc_458x500.webp';
import travauxPublicImg from '../images/TRAVAUX_PUBLIC_GC_458x500.webp';
import architectureImg from '../images/ARCHITECTURE_GC_458x500.webp';
import topographieImg from '../images/topographie_458x500.webp';
import temoin1 from '../images/temoin_gc1_80x80.webp';
import temoin2 from '../images/temoin_gc2_80x80_80x80.webp';
import temoin3 from '../images/temoin_gc3_80x80.webp';
import monImage from '../images/IMG_BTP_PRINCIPAL_1920x780.webp';
import ctaBackground from '../images/formation_genie_civil_900x500.webp';

const CivilEngineering = () => {
  const { t } = useTranslation();

  // Données pour le composant Counter (statistiques)
  const statsData = [
    {
      icon: faUsers,
      target: 3,
      label: t('clients_satisfaits'),
      suffix: '+',
      color: '#4fc3f7',
    },
    {
      icon: faFileAlt,
      target: 0,
      label: t('nbre_formations'),
      suffix: '+',
      color: '#90ee90',
    },
    {
      icon: faFolder,
      target: 3,
      label: t('nbre_projets'),
      suffix: '+',
      color: '#ffb74d',
    },
    {
      icon: faAward,
      target: 2,
      label: t('annees_experience'),
      suffix: '+',
      color: '#f06292',
    },
  ];

  // Données pour le composant Testimonials
  const testimonialsData = [
    {
      text: t('temoin1_gc'),
      name: 'KAMGA JULE',
      role: t('role_temoin1_depart_GC'),
      image: temoin1,
    },
    {
      text: t('temoin2_gc'),
      name: 'SIMO AURELIE',
      role: t('role_temoin2_depart_GC'),
      image: temoin2,
    },
    {
      text: t('temoin3_gc'),
      name: 'KENMOGNE MARTIN',
      role: t('role_temoin3_depart_GC'),
      image: temoin3,
    },
  ];

  return (
    <div className="civil-engineering-page">
    <DepartmentHero
    title={t('civil_card_titre_Notre_expertise')}
    subtitle="Construction d'infrastructures durables"
    breadcrumb={[
        { label: t('Sous_Services_BTP') },
    ]}
    background={monImage}
    badge="Services / Génie Civil"
    height="large"
    />

      <DepartmentAbout
        chefImage={chefImage}
        chefName="M. NDE KALA JUNIOR WILFRIED"
        chefRole={t('CHEF_departement_info')}
        chefSocial={[
          { icon: 'facebook', url: 'https://www.facebook.com/share/16zfczToHo/?mibextid=wwXIfr' },
          { icon: 'whatsapp', url: 'https://wa.me/237695123990' },
          { icon: 'linkedin', url: 'https://www.linkedin.com/public-profile/settings' },
          { icon: 'tiktok', url: 'https://www.tiktok.com/@massawilf?_t=ZM-8zku12yKBmP&_r=1' },
        ]}
        logoImage={logoCivil}
        title={t('titre_departement_civil')}
        subtitle={t('sous_titre_departement_civil')}
        description={t('msg_departement_civil')}
        skills={[
          { label: t('skill1_departement_civil'), percentage: 70, color: '#0066cc' },
          { label: t('skill2_departement_civil'), percentage: 90, color: '#c8a02b' },
          { label: t('skill3_departement_civil'), percentage: 50, color: '#107a3e' },
          { label: t('skill4_departement_civil'), percentage: 75, color: '#6b3fa0' },
          { label: t('skill5_departement_civil'), percentage: 80, color: '#e67e22' },
        ]}
      />

        <DepartmentCTA
        title={t('titre_devis_departement_info')}
        subtitle={t('sous_titre_devis_departement_info')}
        primaryButton={{ label: t('btn_devis_departement_info'), link: '/contact' }} 
        secondaryButton={{ label: t('btn_FORMATION_devis_departement_info'), link: '/formation' }}
        backgroundImage={ctaBackground} 
        badge=" Solutions ATC" // Optionnel
        formationLink="/formation/civil" 
        />

      <DepartmentServices
        title={t('titre_service_departement_info')}
        subtitle={t('sous_titre_service_departement_gc')}
        services={[
          {
            title: t('skill1_departement_civil'),
            icon: faClipboard,
            color: '#0066cc',
            frontDesc: t('etude_tech_msg1_service_departement_gc'),
            backDesc: t('etude_tech_msg2_service_departement_gc'),
            image: etudeTechImg,
            overlayColor: 'rgba(0, 102, 204, 0.66)',
          },
          {
            title: t('skill2_departement_civil'),
            icon: faBuilding,
            color: '#c8a02b',
            frontDesc: t('batiment_msg1_service_departement_gc'),
            backDesc: t('batiment_msg2_service_departement_gc'),
            image: batimentImg,
            overlayColor: 'rgba(200, 160, 43, 0.66)',
          },
          {
            title: t('skill3_departement_civil'),
            icon: faRoad,
            color: '#107a3e',
            frontDesc: t('TP_msg1_service_departement_gc'),
            backDesc: t('TP_msg2_service_departement_gc'),
            image: travauxPublicImg,
            overlayColor: 'rgba(16, 122, 62, 0.66)',
          },
          {
            title: t('skill4_departement_civil'),
            icon: faPencilRuler,
            color: '#6b3fa0',
            frontDesc: t('ACHITECTURE_msg1_service_departement_gc'),
            backDesc: t('ACHITECTURE_msg2_service_departement_gc'),
            image: architectureImg,
            overlayColor: 'rgba(107, 63, 160, 0.66)',
          },
          {
            title: t('skill5_departement_civil'),
            icon: faMap,
            color: '#e67e22',
            frontDesc: t('topographie_msg1_service_departement_gc'),
            backDesc: t('topographie_msg2_service_departement_gc'),
            image: topographieImg,
            overlayColor: 'rgba(230, 126, 34, 0.66)',
          },
        ]}
      />

      {/* Utilisation du composant Counter réutilisable */}
      <Counter stats={statsData} isDark={true} showBar={true} />

      {/* Utilisation du composant Testimonials réutilisable */}
      <Testimonials
        title={t('temoignage')}
        subtitle={t('sous_titre_temoignage')}
        testimonials={testimonialsData}
        isDark={false} // fond clair pour cette page
      />
    </div>
  );
};

export default CivilEngineering;